var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"large":"","title":"Laudos"},scopedSlots:_vm._u([{key:"footer",fn:function({ cancel }){return [_c('rkm-button',{on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('List',{attrs:{"laudos":_vm.laudos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }